import script from "./EditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPage.vue?vue&type=script&setup=true&lang=js"

import "./EditPage.vue?vue&type=style&index=0&id=0a1592b3&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1592b3"]])

export default __exports__